import { render } from "./SponsorBreakdownList.vue?vue&type=template&id=7a6254b2"
import script from "./SponsorBreakdownList.vue?vue&type=script&lang=js"
export * from "./SponsorBreakdownList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__